<template>
  <div class="modal js-modal" :id="name">
    <div class="modal__bg">
      <div class="o-modal__lower-pc">
        <div class="js-modal-close"></div>
        <p class="o-modal__lower-pc__title">{{ title }}</p>
        <div class="o-modal__lower-pc__scroll">
            
            <div v-if="groups" v-for="(group, groupId) in groups" v-bind:key="groupId">
              <p class="title bold">{{group}}</p>
              <div class="flex__content" v-bind:class="{'is-flex1': flex==1, 'is-flex4': flex==4}">
                <label v-for="(item, index) in items[groupId]" v-bind:key="index">
                  <input type="checkbox" name="tags[]" :value="item.value" v-model="values" @click="showTag()">
                  <span>{{ item.label }}</span>
                </label>
              </div>
            </div>

            <div v-if="!groups">
              <div class="flex__content" v-bind:class="{'is-flex1': flex==1, 'is-flex4': flex==4}">
                <label v-for="(item, index) in items" v-bind:key="index">
                  <input type="checkbox" name="tags[]" :value="item.value" v-model="values" @click="showTag()">
                  <span>{{ item.label }}</span>
                </label>
              </div>
            </div>

        </div>
        <div class="o-modal__lower-pc__last">
          <div class="last__height">
            <span v-for="(value, index) in values" v-bind:key="index" v-if="itemList[value]">{{ itemList[value] ? itemList[value].label : ''}}<button @click="removeSelect(value)" type="button"></button></span>
          </div>
          <a class="o-btn__pc-modal" @click="submit()">この条件で案件検索</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: String,
    title: String,
    items : {
      type: Array | Object,
      default: [],
      required: true,
    },
    groups: {
      type: Array | Object | null,
      default: null,
      required: false,
    },
    flex: {
      type: Number | null,
      default: 0,
      required: false,
    },
    selected : {
      type: Array | null,
      default: null,
      required: false,
    },
    isBookmark : {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
  },
  data() {
    return {
      values: this.selected,
      itemList: []
    }
  },
  methods: {
    submit() {
      $('form[name="search"]').submit();
    },

    setList() {
      if (this.groups) {
        _.each(this.groups, (group, key) => {
          _.each(this.items[key], (item, key) => {
            this.itemList[item.value] = item;
          });
        });
      } else {
        _.each(this.items, (item, key) => {
          this.itemList[item.value] = item;
        });
      }
    },

    showTag() {
      $('.p-index__tag__content label').hide();
      $('.p-index__tag__content .list-tags').empty();

      if (this.isBookmark) {
        $('.p-index__tag__content .list-tags').append('<span>スター付き<button onclick="searhJob()"></button></span>');
      }

      let checkeds = $('input[name="tags[]"]:checked');
      if (checkeds.length > 0) {
          checkeds.each(function(chkboxIndex, chkbox) {
              $('.p-index__tag__content .list-tags').append('<span>' + $(chkbox).parent().find('span').text() + '<button type="button" onclick="removeTag(' + $(chkbox).val() + ')"></button></span>');
          })
      } else {
        if (!this.isBookmark) {
          $('.p-index__tag__content label').show();
        }
      }
    },
    removeSelect(val) {
      const index = this.values.indexOf(val);
      if (index > -1) {
        this.values.splice(index, 1);
        
        setTimeout(function(){ showTag() }, 500);
      }

    },
  },
  created() {
    this.setList();
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    values(val) {
    },
  },
}
</script>
